export const storeEstamentRestrict = async (resource, data) => {
    let restriction;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/restriction`, data)
      .then(
        (response) => {
          console.log(response);
          restriction = response.body.restriction;
        },
        (response) => {
          console.log(response);
        }
      );
    return restriction;
  }
  
  export const deleteEstamentRestrict = async (resource, id) => {
    let restriction;
    await resource
      .delete(`api/${localStorage.getItem('perfil')}/restriction/${id}`)
      .then(
        (response) => {
          console.log(response);
          restriction = response.body.restriction;
        },
        (response) => {
          console.log(response);
        }
      );
    return restriction;
  }

